import { render, staticRenderFns } from "./AddEntity.vue?vue&type=template&id=3b52ffe1&"
import script from "./AddEntity.vue?vue&type=script&lang=js&"
export * from "./AddEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEntity.vue"
export default component.exports